import axios from "axios";
import { env } from "../../config/env";
import { authStorage } from "../storage/authStorage";

export const recApiClient = axios.create({
  baseURL: env.recApiBaseUrl,
});

recApiClient.interceptors.request.use((config) => {
  if (!config.headers.Authorization) {
    const token = authStorage.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});
